export enum FilterField {
  CLIENTS = 'CLIENTS',
  AREAS = 'AREAS',
  AREAS_SERVICES = 'AREAS_SERVICES',
  AREAS_SERVICES_ROUTES = 'AREAS_SERVICES_ROUTES',
  AREAS_SERVICES_EXPEDITIONS = 'AREAS_SERVICES_EXPEDITIONS',
  SERVICES_ROUTES = 'SERVICES_ROUTES',
  OPERATORS = 'OPERATORS',
  SENDERS = 'SENDERS',
  RECEIVERS = 'RECEIVERS',
  VEHICLES = 'VEHICLES',
  DRIVERS = 'DRIVERS',
  ORIGIN_DESTINATION = 'ORIGIN_DESTINATION',
  DATE_RANGE = 'DATE_RANGE',
  TIME_RANGE = 'TIME_RANGE',
  BOOKINGS = 'BOOKINGS',
  EXPEDITION_STATUS = 'EXPEDITION_STATUS',
  EXPEDITION_TYPES = 'EXPEDITION_TYPES',
  EXPEDITION_MODES = 'EXPEDITION_MODES',
  SERVICE_TYPES = 'SERVICE_TYPES',
  USER_STATUS = 'USER_STATUS',
  USER_TYPES = 'USER_TYPES',
  SUGGESTION_STATUS = 'SUGGESTION_STATUS',
  SUGGESTION_TYPES = 'SUGGESTION_TYPES',
  SUGGESTION_PRIORITIES = 'SUGGESTION_PRIORITIES',
  SUGGESTION_USER_RESOLUTIONS = 'SUGGESTION_USER_RESOLUTIONS',
  SUGGESTION_VISIBILITIES = 'SUGGESTION_VISIBILITIES',
  MESSAGE_ORIGIN = 'MESSAGE_ORIGIN',
  MESSAGE_EVENTS = 'MESSAGE_EVENTS',
  MESSAGE_ADMIN_ALERTS = 'MESSAGE_ADMIN_ALERTS',
  CLIENT_TYPES = 'CLIENT_TYPES',
  APP_STATUS = 'APP_STATUS',
}

export enum FilterFieldKind {
  MULTISELECT = 'MULTISELECT',
  MULTISELECT_SCROLL = 'MULTISELECT_SCROLL',
  OPTION_MULTISELECT = 'OPTION_MULTISELECT',
  AREAS_SERVICES = 'AREAS_SERVICES',
  RECEIVERS = 'RECEIVERS',
  CHECKBOX_GROUP = 'CHECKBOX_GROUP',
  STATUS_GROUP = 'STATUS_GROUP',
  ORIGIN_DESTINATION = 'ORIGIN_DESTINATION',
  DATE_RANGE = 'DATE_RANGE',
  TIME_RANGE = 'TIME_RANGE',
}
